export default {
    noResources: "Es liegen keine Ressourcen vor.",

    projects: "Projekte",
    donation: "Jetzt Spenden",

    showMoreDetails: "Details anzeigen",
    showLessDetails: "Details ausblenden",

    noResourceBookings: "Keine Belegungen gefunden.",
    noResults: "Keine Belegungen gefunden.",

    page: "Seite {page}",
    firstPage: "Erste Seite",
    nextPage: "Nächste Seite",

    copiedToClipboard: "In die Zwischenablage kopiert",
    subscribeCalendar: "Kalender abonnieren",
    copyIcalUrl: "URL kopieren",
    downloadIcalFile: "Datei herunterladen",

    progress: {
        stillMissing: "Uns fehlen noch ",
        beTheFirst: "Helfen Sie mit der ersten Spende für dieses Projekt!",
        pleaseHelpDonating: ", bitte helfen Sie uns dabei das Spendenziel zu erreichen.",
        achievedGoal: "Wir konnten unser Spendenziel bereits erreichen! Trotzdem freuen wir uns sehr über jede weitere Spende."
    }
}